import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule);

if (environment.pendoApiKey) {
  const script = document.createElement('script');
  script.src = 'https://cdn.pendo.io/agent/static/' + environment.pendoApiKey + '/pendo.js';
  script.async = true;
  document.head.appendChild(script);
}
